module.exports = "pegasus_template/assets/summer_header_image.jpg";